module.exports = __webpack_public_path__ + "img/p2.01d3f95a.png";